import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
interface PurchaseSectionProps {
  id?: string;
}
export function PurchaseSection({
  id
}: PurchaseSectionProps) {
  return <section id={id} className="scroll-mt-10" data-id="element-154">
      {/* Red urgency countdown strip */}
      <div className="bg-red-600 py-3 px-4 text-center border-y-2 border-red-400 shadow-[0_0_30px_rgba(239,68,68,0.3)]" data-id="element-155">
        <p className="text-white font-black text-xs md:text-sm tracking-widest mb-1.5 animate-pulse" data-id="element-156">
          ⏰ El precio de lanzamiento termina en:
        </p>
        <CountdownTimer className="!text-white [&_div]:!border-white/30 [&_div]:!bg-red-700 [&_span]:!text-white/60 !text-lg md:!text-2xl" data-id="element-157" />
        <p className="text-red-200 font-bold text-[10px] mt-1.5" data-id="element-158">
          Después sube el precio y no vuelve a bajar.
        </p>
        <div className="max-w-xs mx-auto mt-2" data-id="element-159">
          <div className="flex justify-between text-[9px] font-bold mb-1" data-id="element-160">
            <span className="flex items-center text-white" data-id="element-161">
              <span className="w-1.5 h-1.5 rounded-full bg-white mr-1 animate-ping" data-id="element-162"></span>
              Cupos al precio de lanzamiento
            </span>
            <span className="text-red-200" data-id="element-163">Quedan pocos</span>
          </div>
          <div className="w-full bg-red-800 rounded-full h-1.5 overflow-hidden" data-id="element-164">
            <div className="bg-white h-1.5 rounded-full w-[78%]" data-id="element-165"></div>
          </div>
          <p className="text-[8px] text-red-200 font-medium mt-0.5 text-right" data-id="element-166">
            78% de los cupos tomados
          </p>
        </div>
      </div>

      {/* Pricing section */}
      <div className="py-6 md:py-8 px-4 bg-brand-cardAlt" data-id="element-167">
        <div className="max-w-3xl mx-auto" data-id="element-168">
          <div className="text-center mb-5" data-id="element-169">
            <h2 className="text-xl md:text-2xl font-black text-white tracking-tight leading-none" data-id="element-170">
              Elegí tu Kit
            </h2>
            <p className="text-xs font-bold text-brand-accent neon-glow mt-1" data-id="element-171">
              Las 2 opciones incluyen los 4 bonos estratégicos
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5" data-id="element-172">
            {/* Basic Kit */}
            <div className="bg-brand-card rounded-lg border border-white/10 p-4 md:p-5 flex flex-col relative" data-id="element-173">
              <h3 className="text-sm md:text-base font-black text-white mb-0.5 leading-tight" data-id="element-174">
                📘 KIT COMPLETO VÓLEY LISTO
              </h3>
              <p className="text-gray-400 font-medium text-xs mb-3" data-id="element-175">
                6 tomos + clases nivel inicial + 4 bonos
              </p>
              <div className="flex items-center justify-center gap-2 mb-4 flex-grow" data-id="element-176">
                <span className="text-xs text-gray-500 line-through font-bold" data-id="element-177">
                  USD 35.00
                </span>
                <span className="text-2xl md:text-3xl font-black text-white" data-id="element-178">
                  USD 13.99
                </span>
              </div>
              <Button href="https://checkout.docentesfelices.online/cart/55643367243849:1" className="py-2.5 text-sm" pulse={false} data-id="element-179">
                → QUIERO EL KIT BASE
              </Button>
            </div>

            {/* Premium Kit */}
            <div className="bg-brand-card rounded-lg border-2 border-brand-accent p-4 md:p-5 flex flex-col relative shadow-[0_0_20px_rgba(0,191,255,0.15)]" data-id="element-180">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-brand-dark font-black px-3 py-0.5 rounded-full text-[10px] tracking-widest shadow-lg whitespace-nowrap" data-id="element-181">
                ⭐ MÁS ELEGIDO
              </div>
              <h3 className="text-sm md:text-base font-black text-white mb-0.5 mt-1 leading-tight" data-id="element-182">
                🏆 KIT COMPLETO + SISTEMA PRO
              </h3>
              <p className="text-brand-accent font-medium text-xs mb-3" data-id="element-183">
                6 tomos + 180 clases todos los niveles + planificación + 4 bonos
              </p>
              <div className="flex flex-col items-center justify-center mb-4 flex-grow" data-id="element-184">
                <div className="flex items-center gap-2" data-id="element-185">
                  <span className="text-xs text-gray-500 line-through font-bold" data-id="element-186">
                    USD 45.00
                  </span>
                  <span className="text-2xl md:text-3xl font-black text-brand-accent neon-glow" data-id="element-187">
                    USD 19.90
                  </span>
                </div>
                <span className="bg-brand-accent text-brand-dark font-black text-[10px] px-2 py-0.5 rounded-full tracking-wider mt-1" data-id="element-188">
                  AHORRÁS USD 25.10
                </span>
              </div>
              <Button href="https://checkout.docentesfelices.online/cart/55643367637065:1" className="py-3 text-sm shadow-[0_0_20px_rgba(0,191,255,0.4)]" pulse={true} data-id="element-189">
                → QUIERO EL KIT COMPLETO
              </Button>
            </div>
          </div>

          <p className="text-[9px] md:text-[10px] text-gray-500 text-center mb-4 font-medium leading-relaxed max-w-lg mx-auto" data-id="element-190">
            El precio está en dólares estadounidenses (USD). El cobro se realiza
            automáticamente en la moneda de tu país al tipo de cambio del
            momento. Pagás en pesos argentinos, pesos mexicanos, pesos
            colombianos, soles peruanos, pesos chilenos, guaraníes, bolívares,
            quetzales, lempiras, colones, balboas, córdobas o cualquier otra
            moneda local.
          </p>

          <div className="flex flex-wrap justify-center gap-3 text-[10px] text-gray-400 font-medium" data-id="element-191">
            <div className="flex items-center" data-id="element-192">
              <Lock className="w-3 h-3 mr-1 text-brand-accent" data-id="element-193" />
              <span data-id="element-194">Pago 100% seguro</span>
            </div>
            <div className="flex items-center" data-id="element-195">
              <Zap className="w-3 h-3 mr-1 text-brand-accent" data-id="element-196" />
              <span data-id="element-197">Acceso en 5 min</span>
            </div>
            <div className="flex items-center" data-id="element-198">
              <ShieldCheck className="w-3 h-3 mr-1 text-brand-accent" data-id="element-199" />
              <span data-id="element-200">Garantía 7 días</span>
            </div>
            <div className="flex items-center" data-id="element-201">
              <CreditCard className="w-3 h-3 mr-1 text-brand-accent" data-id="element-202" />
              <span data-id="element-203">Tarjeta · Transferencia · Pago local</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}